import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Dust20Card(props) {
  const { data, handle } = props;

  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center gap-2 border-borderColor border-[1px] border-solid bg-gray-900 p-5 rounded-md cursor-pointer" onClick={handle}>
      <div className="text-primary font-bold text-[20px]">{data.tick.toUpperCase()}</div>
      <div>{t('Amount')}: {data.amount}</div>
    </div>
  )
}
